// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PullRequestOutlinedSvg from "@ant-design/icons-svg/es/asn/PullRequestOutlined";
import AntdIcon from '../components/AntdIcon';

var PullRequestOutlined = function PullRequestOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PullRequestOutlinedSvg
  }));
};

PullRequestOutlined.displayName = 'PullRequestOutlined';
export default React.forwardRef(PullRequestOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PullRequestOutlined.js
// module id = 1637
// module chunks = 0